/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Profile_Update_Ready_BodyInputs */

const en_us2_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} is downloaded. The app will restart to open it.`)
};

const pt_br2_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A versão ${i?.version} já foi baixada. O app vai reiniciar para abri-la.`)
};

const es_419_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La versión ${i?.version} ya se descargó. La app se reiniciará para abrirla.`)
};

const pt_pt2_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A versão ${i?.version} já foi transferida. A app vai reiniciar para a abrir.`)
};

const fr_fr2_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La version ${i?.version} est téléchargée. L'app va redémarrer pour l'ouvrir.`)
};

const de_de2_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} ist heruntergeladen. Die App startet neu, um sie zu öffnen.`)
};

const it_it2_profile_update_ready_body = /** @type {(inputs: Profile_Update_Ready_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La versione ${i?.version} è stata scaricata. L'app si riavvierà per aprirla.`)
};

/**
* | output |
* | --- |
* | "Version {version} is downloaded. The app will restart to open it." |
*
* @param {Profile_Update_Ready_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_ready_body = /** @type {((inputs: Profile_Update_Ready_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_Ready_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_ready_body(inputs)
	if (locale === "es-419") return es_419_profile_update_ready_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_ready_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_ready_body(inputs)
	if (locale === "de-DE") return de_de2_profile_update_ready_body(inputs)
	if (locale === "it-IT") return it_it2_profile_update_ready_body(inputs)
	return en_us2_profile_update_ready_body(inputs)
});
export { profile_update_ready_body as "profile.update_ready_body" }